export { default as getLogDestination } from './createDestination'
export { default as removeLogDestination } from './removeDestination'
